import { withErrorBoundary } from '@sentry/react';
import * as React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useSubscription } from 'urql';
import MenuSidebar from '../../components/navigation/menu-sidebar/menu-sidebar';
import NotificationsSidebar from '../../components/ui-utils/notifications-sidebar/notifications-sidebar';
import { Fallback } from '../../components/utils/error-boundary';
import HideableComponent from '../../components/utils/hideable-component';
import Timeout from '../../components/utils/timeout';
import { GraphqlOperations } from '../../logic/graphql/operations';
import { AuthToken, Subscription } from '../../logic/graphql/types/types';
import Auth from '../../logic/redux/auth';
import { Paths } from '../../navigation/paths';
import { ScreenSizeFloor } from '../../styles/screen-sizes';
import MainFrame from '../main-frame/main-frame';

const MainScreen = (): JSX.Element => {
  const dispatch = useDispatch();
  const location = useLocation();
  const handleSubscription = (tokens: AuthToken[] = [], response: Subscription): AuthToken[] => {
    if (response && response.new_token) {
      if (response.new_token.expiry === 0) {
        dispatch(Auth.actions.doLogout());
      } else {
        dispatch(Auth.actions.doSetAuthenticationToken(response.new_token));
      }
      return [response.new_token, ...tokens];
    }
    return tokens;
  };

  useSubscription(
    {
      query: GraphqlOperations.subscriptions.new_token.subscriptionString,
    },
    handleSubscription,
  );

  const showNotificationsSideMenu = location.pathname === Paths.dashboard;

  return (
    <>
      <div className="main-screen">
        <div className="main-screen-content flex">
          <HideableComponent showFrom={ScreenSizeFloor.LG}>
            <MenuSidebar />
          </HideableComponent>
          <MainFrame />
          {showNotificationsSideMenu && (
            <HideableComponent showFrom={ScreenSizeFloor.XL}>
              <NotificationsSidebar />
            </HideableComponent>
          )}
        </div>
      </div>
      <Timeout />
    </>
  );
};

export default withErrorBoundary(MainScreen, { fallback: Fallback });
